"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("modules/onlineEvent/helpers");
class LabelUtils {
    static pluralize(label, amount) {
        if (amount === 0) {
            return `${label}_empty`;
        }
        if (amount > 1) {
            return `${label}_plural`;
        }
        return label;
    }
}
LabelUtils.customize = (label, data) => {
    let customLabel = label;
    if (data === null || data === void 0 ? void 0 : data.checkOnlineEvent) {
        customLabel = (0, helpers_1.onlineEventLabelHandler)(label);
    }
    if (typeof (data === null || data === void 0 ? void 0 : data.amountToPluralize) !== 'undefined') {
        customLabel = LabelUtils.pluralize(customLabel, data.amountToPluralize);
    }
    return customLabel;
};
exports.default = LabelUtils;
